"use client";

import Link from "next/link";
import { useState } from "react";

const features = [
  {
    name: "Research-Ready & Clean",
    description:
      "Skip months of data wrangling. Our datasets are pre-processed, validated, and enriched with features like text analysis, sentiment detection, and multimodal content parsing. Periodic ingestion crawls ensures relevant and up to date content, reflecting recent discussion topics and trends.",
    href: "#",
    img: "/images/clean data.png",
  },
  {
    name: "Robust & Reliable",
    description:
      "No more broken APIs or failed scrapers. Our engineering infrastructure is built to scale—handling real-time media offloading, cloud storage, and high-volume data flows—so you can focus on research, not troubleshooting SQLite errors.",
    href: "#",
    img: "/images/robust data.png",
  },
  {
    name: "Comprehensive & Multi-Platform",
    description:
      "Access scientifically sampled, validated data from major social platforms—all in one place. Our datasets include translated content and historical trend tracking, giving you a full-spectrum view of the digital landscape.",
    href: "#",
    img: "/images/multiplatform.png",
  },
];

const PlatformOverview = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="bg-white from-bgHome via-[#172035] to-bgHome dark:border-gray-700 dark:bg-gradient-to-r">
      <div className="relative isolate overflow-hidden">
        <div className="py-32 sm:py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:text-center">
              <h2 className="text-base font-semibold leading-7 text-[#348ddb]">
                Platform
              </h2>
              <p className="mt-2 text-pretty text-4xl font-semibold tracking-tight text-[#002243] dark:text-white lg:text-balance">
                A Platform for Multimedia Information Research
              </p>
              <p className="mt-6 text-lg/8 text-[#002243] dark:text-gray-400">
                Analyze clean, standardized data designed for rigorous research
                on today&apos;s complex, cross-platform information environment.
              </p>
            </div>
            <div className="mx-auto mt-16 max-w-2xl sm:my-20 lg:max-w-none">
              <dl className="mx-auto grid max-w-6xl grid-cols-1 gap-x-8 gap-y-16 lg:grid-cols-3">
                {features.map((feature) => (
                  <div
                    key={feature.name}
                    className="flex flex-col items-center"
                  >
                    <dt className="mb-5 items-center p-4">
                      <img
                        height={75}
                        width={75}
                        src={feature.img}
                        alt="feature-icon"
                      />
                    </dt>
                    <dt className="flex items-center gap-x-3 text-base/7 font-semibold text-[#002243] dark:text-gray-200">
                      {feature.name}
                    </dt>
                    <dd className="mt-4 flex flex-auto flex-col text-base/7 text-gray-600 dark:text-gray-400">
                      <p className="flex-auto">{feature.description}</p>
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <a
                href="/auth/login?screen_hint=signup&returnTo=/auth/verify-email"
                className="text-md cursor-pointer rounded border border-[#002243] bg-[#F4F6FB] p-2 font-semibold leading-6 text-[#002243] hover:bg-[#e9ebf0] dark:border-gray-400 dark:bg-transparent dark:font-medium dark:text-gray-300 hover:dark:bg-white/5 hover:dark:backdrop-blur "
              >
                Start Your Research
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformOverview;
